import {BACKEND_URL} from './constants/apiConstants'
import {getIsAdminUI} from './utils/authUtil'
import {urlUtil} from './utils/urlUtil'

/**
 * The base URL for the surface being served *right now*. Admin talks to the `/admin/*`
 * route tree; portal (and the handful of standalone public routes `getIsAdminUI()`
 * exempts by path — see authUtil.ts) keep their original, unprefixed paths.
 *
 * Called fresh on every request rather than cached at import — `window.location` can change
 * after this module first loads (client-side navigation, or a test's `setWindowLocation()`),
 * and a cached value would silently keep serving whichever surface was live at import time.
 */
export const getApiBaseUrl = (): string =>
  urlUtil.joinUrl(BACKEND_URL ?? '', getIsAdminUI() ? 'admin' : '')
